import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from './../../actions'
import SelectPrice from './../../components/site/select_price'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  siteItemsApi: state.siteItemsApi,
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectPriceStart: state.searchFormCondition.selectPriceStart,
  selectPriceFinish: state.searchFormCondition.selectPriceFinish,
})

const SelectPriceContainer = connect(mapStateToProps, mapDispatchToProps)(SelectPrice)

export default SelectPriceContainer
